var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"answer"},[_c('p',[_vm._t("default")],2),_c('img',{attrs:{"src":require("@/assets/img/check.svg"),"alt":"Selected"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }